module.exports = __webpack_public_path__ + "static/media/skill_icon_summoner.ee0c22ea.png";